module.exports = __webpack_public_path__ + "img/SHOW.8ac8e704.svg";